module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAABSElEQVQ4je3VP0pDQRDH8U8kAUHUJiQKKSwkoLXJEUQEFRtbz5DKM9joPdKoeAjhYa0gIoKCPBAUbISHYLErPp9/2Iilv3J297szszsztXqr9+ijzrGGe2lq4hgLZeNYZdPliFBFnt3HMxc/gTtYTIWWNIfZr8AXeMI4hvGCJDXa/TYOMIlnIWpjQk5XsRnhu7hNBRd5lmMvQrewgvNavdVres/pDKYxwFQi+zE681Lk2W2Molmrt3rVjUMsp3ocdVTk2XbZUH08mBgRSvhyH/QV+E/0D/4Hp4FvfsE5qxqqJd3BAzaE0k7RAw7RrJb0idBPF4Vy3sV+qqtFnmm0+wPsYB1XOK7FCXIZvR0XOtwS8kR2B6els3fovuV4vrSwOQJUDH9LaJuT6PL58e5wnQot6Uylh1fBXWEwfupW36nR7r8N0/my/RXNKVC67lFV1wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/fang1.png
// module id = RZA6
// module chunks = 601